/* eslint-disable */
import React, { useState, useRef, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import "./AudioAffichage.css";

const BARS = 48;
const SPEEDS = [1, 1.5, 2, 0.5];

function generateHeights() {
  return Array.from({ length: BARS }, () => Math.random() * 0.65 + 0.35);
}

function fmt(s) {
  return `${Math.floor(s / 60)}:${String(Math.floor(s % 60)).padStart(2, "0")}`;
}

const AudioWaveform = ({ recordingUrl, color = "#7c3aed", dimColor = "#d8b4fe" }) => {
  const { i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [speedIdx, setSpeedIdx] = useState(0);
  const [heights] = useState(generateHeights);
  const audioRef = useRef(null);
  const waveRef = useRef(null);

  const speed = SPEEDS[speedIdx];
  const pct = duration > 0 ? (currentTime / duration) * 100 : 0;

  const togglePlay = () => {
    if (!audioRef.current) return;
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.playbackRate = speed;
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  const seekWave = (e) => {
    if (!waveRef.current || !audioRef.current || !duration) return;
    const { left, width } = waveRef.current.getBoundingClientRect();
    const ratio = Math.max(0, Math.min(1, (e.clientX - left) / width));
    audioRef.current.currentTime = ratio * duration;
    setCurrentTime(ratio * duration);
  };

  const cycleSpeed = () => {
    const next = (speedIdx + 1) % SPEEDS.length;
    setSpeedIdx(next);
    if (audioRef.current) audioRef.current.playbackRate = SPEEDS[next];
  };

  useEffect(() => {
    const el = audioRef.current;
    if (!el) return;
    const onTime = () => setCurrentTime(el.currentTime);
    const onMeta = () => setDuration(el.duration);
    const onEnd = () => { setIsPlaying(false); setCurrentTime(0); };
    el.addEventListener("timeupdate", onTime);
    el.addEventListener("loadedmetadata", onMeta);
    el.addEventListener("ended", onEnd);
    return () => {
      el.removeEventListener("timeupdate", onTime);
      el.removeEventListener("loadedmetadata", onMeta);
      el.removeEventListener("ended", onEnd);
    };
  }, []);

  if (!recordingUrl) return null;

  return (
    <div className={`aw-pill ${isRTL ? 'aw-rtl' : 'aw-ltr'}`} dir={isRTL ? "rtl" : "ltr"}>
      <audio ref={audioRef} src={recordingUrl} />

      <button
        className="aw-btn"
        style={{ background: color }}
        onClick={togglePlay}
      >
        {isPlaying ? (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
            <rect x="6" y="4" width="4" height="16" />
            <rect x="14" y="4" width="4" height="16" />
          </svg>
        ) : (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
            <polygon points="5 3 19 12 5 21 5 3" />
          </svg>
        )}
      </button>

      <div className="aw-body">
        <div className="aw-wave" ref={waveRef} onClick={seekWave}>
          {heights.map((h, i) => (
            <div
              key={i}
              className="aw-bar"
              style={{
                height: `${Math.round(h * 100)}%`,
                background: i / BARS < pct / 100 ? color : dimColor,
              }}
            />
          ))}
        </div>

        <div className="aw-footer">
          <span className="aw-time" style={{ color }}>{fmt(currentTime)}</span>
          <button className="aw-speed" onClick={cycleSpeed}>{speed}×</button>
          <span className="aw-dur">{duration > 0 ? fmt(duration) : "--:--"}</span>
        </div>
      </div>
    </div>
  );
};

export default AudioWaveform;